import { throwErrorWithStack } from "./crashlytics";
import { getLogger } from "./logging";

const log = getLogger("Events");

let passiveIfSupported = false;

try {
  window.addEventListener(
    "test",
    null,
    Object.defineProperty({}, "passive", {
      get() {
        passiveIfSupported = { passive: true };
        return true;
      },
    })
  );
} catch (err) {
  throwErrorWithStack(err);
}

export const addTouchEvent = (
  el,
  func,
  passive = true,
  listenerTag = "listener",
  eventType = "click"
) => {
  if (typeof func !== "function")
    log.error("Provided handler is not a function");
  if (el.getAttribute(listenerTag) !== "true") {
    el.addEventListener(eventType, func, passive ? passiveIfSupported : true);
    el.funcref = func;
  }
  el.setAttribute(listenerTag, "true");
};

export const removeAllTouchEvents = (el, listenerTag = "listener") => {
  if (!el.funcref) {
    log.warn("No listeners to remove");
    return;
  }
  el.removeEventListener("touchstart", el.funcref);
  el.removeEventListener("click", el.funcref);
  el.setAttribute(listenerTag, "false");
};
